"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIMENSION_INPUT_DEFAULTS = void 0;
exports.DIMENSION_INPUT_DEFAULTS = {
    backgroundVisualizer: { opacity: { value: 100, unit: '%' } },
    borderVisualizer: { width: { value: 0, unit: 'px' } },
    colorAdder: {
        hex: '#FFFFFF',
        hsb: { hue: 0, saturation: 0, value: 100 },
        rgb: [255, 255, 255],
    },
    colorPicker: {
        opacity: { value: 100, unit: '%' },
    },
    cornerVisualizer: { radius: '0px' },
    edgeVisualizerFactory: { edges: { value: 0, unit: 'px' } },
    flexChildSpacing: { spaceBetweenTextAndIcon: { value: 0, unit: 'px' } },
    gradientPicker: { scale: '100%', angle: { value: 0, unit: 'deg' } },
    iconVisualizer: {
        angle: { value: 0, unit: 'deg' },
        opacity: { value: 100, unit: '%' },
        size: '6px',
    },
    imageFill: {
        customScale: '100%',
        tileScale: '100%',
    },
    singleShadowInput: {
        angle: { value: 0, unit: 'deg' },
        blur: '0px',
        distance: '0px',
        spread: '0px',
    },
    shadowsVisualizerFactory: { opacity: { value: 100, unit: '%' } },
    textVisualizer: {
        fontSize: '6px',
        letterSpacing: '0em',
        lineHeight: '1.2em',
    },
};
//# sourceMappingURL=dimension-input-defaults.js.map